module.exports = __webpack_public_path__ + "assets/img/30_866_big.175736fa.jpg";